import {
  Autocomplete,
  Box,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import React, { useEffect, useState } from "react";
import { TableList } from "./table";
import { PPagination } from "../../Common/PPagination";

import { primary, secondary } from "../../../Styles/theme";
import ReportsService from "../../../Libs/Services/Reports.service";
import { IReport } from "../../../Libs/Models/IReport.model";
import { PPage } from '../../../Libs/Constants/size';
import { IProfile } from '../../../Libs/Models/IProfile.model';
import { TableStudentList } from './table_student';

interface IProps {
  logoutCallback?: () => void;
}

export function StudentList(props: IProps) {
  const [rowsPerPage, setRowsPerPage] = useState(PPage);
  const [curPage, setCurPage] = useState(1);
  const [report, setReport] = useState<IReport[]>([]);
  const [dataReportShow, setDataReportShow] = useState<IReport[]>([]);
  const [year, setYear] = useState<string[]>(["ทั้งหมด"]);

  const [student, setStudent] = useState<IProfile[]>([]);
  const [dataStudentShow, setDataStudentShow] = useState<IProfile[]>([]);
  const [filter, setFilter] = useState<string>("Report");

  useEffect(() => {
    fetchData("Report");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //All IReport
  async function fetchData(value: string) {
    setFilter(value);
    if (value === "Report") {
      ReportsService.findReports()
        .then((res) => {
          setReport(res);
          setDataReportShow(res);

          var _y_ = Array.from(new Set(res.map(({ year }) => year)));
          _y_.sort();
          _y_.reverse();
          _y_.unshift("ทั้งหมด");
          setYear(_y_);
          setCurPage(1);
        })
        .catch((e) => {
          props.logoutCallback && props.logoutCallback();
        });
    } else if (value === "All") {
      ReportsService.findUsers()
        .then((res) => {
          setStudent(res);
          setDataStudentShow(res);

          var _y_ = Array.from(new Set(res.map(({ year }) => year)));
          _y_.sort();
          _y_.reverse();
          _y_.unshift("ทั้งหมด");
          setYear(_y_);
          setCurPage(1);
        }).catch((e) => {
          props.logoutCallback && props.logoutCallback();
        });
    }
  }
  //--------------------------------------------------//
  //--------------------------------------------------//
  ///// Year /////
  const handleChageYear = (e: React.SyntheticEvent, value: string) => {
    if (filter === "Report") {
      if (value === "ทั้งหมด") {
        setDataReportShow(report);
      } else {
        var data_report = report.filter((row: any) => row.year === value);
        setDataReportShow(data_report);
      }
    } else {
      if (value === "ทั้งหมด") {
        setDataStudentShow(student);
      } else {
        var data_student = student.filter((row: any) => row.year === value);
        setDataStudentShow(data_student);
      }
    }
    setCurPage(1);
  };

  ///// Table /////
  const handleChangeRowsPerPage = (value: string) => {
    setRowsPerPage(Number(value));
    setCurPage(1);
  };

  const handleChangePage = (value: number) => {
    setCurPage(value);
  };
  
  const handleChangeRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
    fetchData(event.target.value);
  }

  //--------------------------------------------------//
  //--------------------------------------------------//
  return (
    <div className="flex-g">
      <Toolbar variant="dense" />
      <div id="header-bar">
        <Box sx={{ backgroundColor: secondary, p: 2 }}>
          <Typography variant="h5" sx={{ pb: 1 }} color={"#000"}>
            ข้อมูลนักศึกษา
          </Typography>

          <RadioGroup
            row
            aria-labelledby="radio-buttons-group-label"
            defaultValue="Report"
            name="radio-buttons-group"
            onChange={handleChangeRadio}
          >
            <FormControlLabel value="Report" control={<Radio />}
              label={<Typography variant="body2" color="font_black" sx={{ py: 0, pr: 2 }}>การทำแบบทดสอบ</Typography>}
            />
            <FormControlLabel value="All" control={<Radio />}
              label={<Typography variant="body2" color="font_black" sx={{ py: 0, pr: 2 }}>ทั้งหมด</Typography>}
            />
          </RadioGroup>

          <Autocomplete
            id="year"
            options={year}
            sx={{ width: 275 }}
            renderInput={(params) => (
              <Paper sx={{ p: 1 }} elevation={0}>
                <TextField
                  {...params}
                  hiddenLabel
                  fullWidth
                  variant="standard"
                  sx={{
                    ".MuiAutocomplete-endAdornment": {
                      right: -8,
                      top: -10,
                    },
                  }}
                  InputProps={{
                    ...params.InputProps,
                    disableUnderline: true,
                  }}
                />
              </Paper>
            )}
            popupIcon={
              <ArrowDropDownIcon
                sx={{
                  backgroundColor: primary,
                  height: 60,
                  width: 43,
                  color: "#fff",
                  borderRadius: 1,
                }}
              />
            }
            onChange={handleChageYear}
            PaperComponent={CustomPaper}
            defaultValue={year[0]}
            disableClearable
            size="small"
          />
        </Box>
      </div>
      <div id="detail">
        {filter === "Report" ?
          <Box sx={{ px: 2, pb: 2 }}>
            <div className="dis-flex flex-row flex-m">
              <Typography variant="body2" color="primary" sx={{ py: 2, pr: 2 }}>
                {`ข้อมูลการทำแบบทดสอบ`}
              </Typography>
            </div>
            <TableList
              data={dataReportShow.slice(
                (curPage - 1) * rowsPerPage,
                (curPage - 1) * rowsPerPage + rowsPerPage
              )}
            />
            <div className="p-t-20">
              <PPagination
                quantity={dataReportShow.length}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                onChagePage={handleChangePage}
              />
            </div>
          </Box> :
          <Box sx={{ px: 2, pb: 2 }}>
            <div className="dis-flex flex-row flex-m">
              <Typography variant="body2" color="primary" sx={{ py: 2, pr: 2 }}>
                {`ข้อมูลบัญชีนักศึกษา`}
              </Typography>
            </div>
            <TableStudentList
              data={dataStudentShow.slice(
                (curPage - 1) * rowsPerPage,
                (curPage - 1) * rowsPerPage + rowsPerPage
              )}
            />
            <div className="p-t-20">
              <PPagination
                quantity={dataStudentShow.length}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                onChagePage={handleChangePage}
              />
            </div>
          </Box>
        }
      </div>
    </div>
  );
}

const CustomPaper = (props: any) => {
  return <Paper elevation={2} {...props} sx={{ mt: 1, width: 275, ml: -1 }} />;
};
